module.exports = __webpack_public_path__ + "static/media/atuacaoVoluntariaLogo.eda9c335.svg";